import React from 'react';
import classnames from 'classnames';
import { Media, Content, Signup } from '../components';
import ProjectsArchive from '../components/ProjectsArchive';
import PortfolioContact from './PortfolioContact';

const PortfolioText = ({
  text,
  stories,
  storyTitle,
  bgColour,
  hideSignup,
  opacity,
  clickable,
  active,
  listId,
  archive,
}) => {
  const hasArchive = archive && archive.length > 0;

  const cls = classnames('PortfolioOutro', {
    'PortfolioOutro--events': clickable,
    'PortfolioOutro--active': active,
    'PortfolioOutro--has-archive': hasArchive,
  });

  const style = {
    opacity: opacity,
    backgroundColor: bgColour || '#fda028',
  };

  return (
    <div className={cls} style={style}>
      <div className="PortfolioOutro-text">
        <Content html={text} modifier="outro" />
        <p>&nbsp;</p>

        {!hideSignup && <Signup listId={listId} />}

        {/* {!hideSignup && (
          <p>
            <input
              type="text"
              placeholder="sign-up for posts"
              value={email}
              onChange={(e) => handleChange(e)}
            />
          </p>
        )} */}
      </div>
      {stories && stories.length > 0 && (
        <div className="PortfolioOutro-stories">
          <h3>{storyTitle}</h3>
          <div className="Stories">
            {stories.map((story, key) => {
              return (
                <div className="Story" key={key}>
                  <a href={story.link} target="_blank">
                    <Media
                      src={story.image.url}
                      kind={story.image.kind}
                      ratio={1}
                      autoplay={true}
                      playOnVisible={false}
                      controls={false}
                    />
                    <div class="Story-text">
                      <p>{story.text}</p>
                    </div>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {/* {stories && stories.length === 0 && (
        <div className="PortfolioOutro-stories">
          <h3>&nbsp;</h3>
        </div>
      )} */}
      {hasArchive && (
        <div className="PortfolioOutro-archive">
          <ProjectsArchive projects={archive} />
          <PortfolioContact />
        </div>
      )}
      {!hasArchive && <PortfolioContact />}
    </div>
  );
};

export default PortfolioText;



// WEBPACK FOOTER //
// ./src/js/components/PortfolioText.jsx